import React from 'react';
import logo from '../../images/favicons/main_logo.png';

const IconLogo = () => (
  <img id="logo" src={logo} alt="Logo" />
);

export default IconLogo;
